<div class="operator-bg" style="overflow-x:auto; padding:15px">
	<!-- Header -->
	<div style="display:flex; align-items:center; justify-content:space-between;">
		<div>
			<h1 style="color:white; padding-left:11px; font-size:1.5rem;">Production Overview</h1>
			<span style="color:#77787F; padding-left:11px; font-size:0.82rem;">Last Refresh: {{this.lastRefresh}} <span style="color:#DAFDCB">(Auto Refresh On)</span></span>
			</div>
		<div style="display:flex; align-items:center; gap:8px; padding-right:8px;">
			<div style="min-width:60px; height:38px; background-color:#1DFF00; border-radius:19px; text-align:center; padding:6px 16px 0;">
				<h3 style="font-size:1rem; margin:0;">{{this.prodAct}}</h3>
			</div>
			<div style="min-width:60px; height:38px; background-color:#FFA500; border-radius:19px; text-align:center; padding:6px 16px 0;">
				<h3 style="font-size:1rem; margin:0;">{{this.prodAmb}}</h3>
			</div>
			<div style="min-width:60px; height:38px; background-color:red; border-radius:19px; text-align:center; padding:6px 16px 0;">
				<h3 style="font-size:1rem; margin:0;">{{this.prodRed}}</h3>
			</div>
		</div>
	</div>

	<!-- Alert pills (supervisor + breakdown) -->
	<div *ngIf="supervisorMachines.length > 0 || breakdownMachines.length > 0" style="padding: 4px 11px 8px; display:flex; flex-wrap:wrap; gap:8px;">
		<div *ngFor="let m of supervisorMachines" class="supervisor-pill supervisor-pill--amber">
			<i class="fas fa-bell" style="margin-right:8px;"></i>
			SUPERVISOR REQUIRED — <strong>{{m.cellNumber}}</strong>
		</div>
		<div *ngFor="let m of breakdownMachines" class="supervisor-pill supervisor-pill--red">
			<i class="fas fa-exclamation-triangle" style="margin-right:8px;"></i>
			BREAKDOWN — <strong>{{m.cellNumber}}</strong>
		</div>
	</div>

	<!-- Page indicator dots -->
	<div *ngIf="totalPages > 1" class="pi-page-indicator">
		<span *ngFor="let p of [].constructor(totalPages); let i = index" class="pi-page-dot" [class.pi-page-dot--active]="i === pageIndex"></span>
		<span class="pi-page-label">Page {{pageIndex + 1}} of {{totalPages}}</span>
	</div>

	<!-- 3-column × n-row machine grid -->
	<div class="row" style="margin-top:7px;">
		<div *ngFor="let machine of pagedMachines" class="col-4 g-10" style="display:flex; flex-direction:column;">
			<div class="activeContainer" [style.border-color]="renderStatusColor(machine.productionStatus)">

				<!-- Machine header: cell number + status -->
				<h3 style="color:white; font-size:1.12rem; margin-bottom:7px;">{{machine.cellNumber}} - <span
						[style.color]="renderStatusColor(machine.productionStatus)">
						{{renderStatusName(machine.productionStatus)}}
					</span>
				</h3>

				<!-- ── STANDARD machine (non-FW) ── -->
				<ng-container *ngIf="!machine.isFW">

					<!-- Current job info -->
					<div *ngIf="machine.runningStages.length > 0" class="row">
						<div class="col-9">
							<div class="row">
								<div class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Part <br /> <span style="color:white;">{{machine.runningStages[0].partNumber.slice(0,20)}}</span></div>
								<div class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Work Order <br /> <span style="color:white;">{{machine.runningStages[0].workOrderId}}</span></div>
								<div class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Operation <br /> <span style="color:white;">{{machine.runningStages[0].operationNumber}}</span></div>
							</div>
							<div class="row">
								<div class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Client <br /> <span style="color:white;">{{machine.runningStages[0].clientName.slice(0,20)}}</span></div>
								<div *ngIf="machine.runningStages[0].assignedUserProfileId > 0" class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Operator <br /> <span style="color:white;">{{machine.runningStages[0].assignedUserProfileFullName}}</span></div>
								<div *ngIf="machine.runningStages[0].assignedUserProfileId == null" class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Operator <br /> <span style="color:red;">No Operator</span></div>
								<div class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Quantity <br /> <span style="color:white;">{{machine.runningStages[0].quantityCompleted}}/{{machine.runningStages[0].quantityRequired}}</span></div>
							</div>
						</div>
						<div class="col-3">
							<img style="height:97px; max-width:100%;" [src]="machine.runningStages[0].partImage">
						</div>
					</div>

					<!-- Progress bar -->
					<div *ngIf="machine.runningStages.length > 0" class="row">
						<div class="col-12" style="padding:4px;">
							<div style="width:100%; height:21px; background-color:#2B2B38; border-radius:21px; overflow:hidden;">
								<div style="width:{{machine.runningStages[0].quantityCompleted/machine.runningStages[0].quantityRequired * 100}}%; height:100%; background-color:#1DFF00; padding-left:17px; border-radius:21px; font-size:0.79rem; line-height:21px;">
									{{(machine.runningStages[0].quantityCompleted/machine.runningStages[0].quantityRequired * 100).toFixed(0)}}%
								</div>
							</div>
						</div>
					</div>

					<!-- No active job -->
					<div *ngIf="machine.runningStages.length == 0" class="no-job-box">
						<div style="display:flex; align-items:flex-start; gap:12px;">
							<div class="no-job-img"></div>
							<div style="flex:1; min-width:0;">
								<p style="color:white; font-size:0.75rem; font-weight:500; margin:0 0 2px 0;">No Work Order Assigned.</p>
								<p style="color:#d1d5db; font-size:0.7rem; margin:0 0 2px 0;"></p>
								<p style="color:#9ca3af; font-size:0.65rem; margin:0 0 6px 0;"></p>
							</div>
						</div>
						<div style="margin-top:4px; height:4px; background-color:#4b5563; border-radius:99px;"></div>
					</div>

					<!-- Divider -->
					<div style="border-top: 1px solid #383046; margin: 8px 0;"></div>

					<!-- Next 3 jobs -->
					<div>
						<h4 style="color:#77787F; font-size:0.72rem; margin-bottom:7px;">Next Jobs</h4>
						<div style="display:flex; flex-direction:column; gap:5px;">
							<ng-container *ngFor="let stage of getNextJobsPadded(machine)">
								<div *ngIf="stage" class="next-job-item" [class.next-job-item--pending]="stage.isPending === true" [class.next-job-item--ready]="stage.isPending === false">
									<div class="pending-indicator">
										<div *ngIf="stage.isPending === true" class="pending-dot pending-dot--red"></div>
										<div *ngIf="stage.isPending === false" class="pending-dot pending-dot--green"></div>
									</div>
									<div class="next-job-img"><img [src]="stage.partImage" alt="Part"></div>
									<div style="flex:1; min-width:0;">
										<p style="color:white; font-size:0.88rem; font-weight:500; margin:0 0 1px 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{stage.partNumber}}</p>
										<p style="color:white; font-size:0.83rem; margin:0 0 1px 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">Op: {{stage.operationNumber}} &middot; {{stage.clientName}} &middot; Qty: {{stage.quantityRequired}}</p>
										<p style="color:#77787F; font-size:0.75rem; margin:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">Planned: {{formatPlannedDate(stage.estimatedStartDate) || 'No Date Planned'}}</p>
									</div>
									<div class="allocation-icons">
										<i class="fas fa-box allocation_status_{{stage.materialAllocationStatus}}"></i>
										<i class="fas fa-screwdriver allocation_status_{{stage.fixingsAllocationStatus}}"></i>
									</div>
								</div>
								<div *ngIf="!stage" class="next-job-item next-job-empty">
									<div class="next-job-img next-job-img-empty"></div>
									<p style="color:#77787F; font-size:0.88rem; margin:0; font-style:italic;">No Job Queued</p>
								</div>
							</ng-container>
						</div>
					</div>

				</ng-container>

				<!-- ── FW machine (EDI orders) ── -->
				<ng-container *ngIf="machine.isFW">

					<!-- Current EDI order info -->
					<div *ngIf="machine.firewallOrders.length > 0" class="row">
						<div class="col-9">
							<div class="row">
								<div class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Part <br /> <span style="color:white;">{{machine.firewallOrders[0].partNumber?.slice(0,20)}}</span></div>
								<div class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Packaging <br /> <span style="color:white;">{{machine.firewallOrders[0].partPackagingExternalName}}</span></div>
								<div class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Quantity <br /> <span style="color:white;">{{machine.firewallOrders[0].quantityOrdered}}</span></div>
							</div>
							<div class="row">
								<div class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Client <br /> <span style="color:white;">{{machine.firewallOrders[0].clientName?.slice(0,20)}}</span></div>
								<div *ngIf="machine.firewallOrders[0].operatorId" class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Operator <br /> <span style="color:white;">{{machine.firewallOrders[0].operatorFullName}}</span></div>
								<div *ngIf="!machine.firewallOrders[0].operatorId" class="col-4" style="padding:5px; color:#77787F; font-size:0.79rem;">Operator <br /> <span style="color:red;">No Operator</span></div>
								<div class="col-4"></div>
							</div>
						</div>
						<div class="col-3">
							<img style="height:97px; max-width:100%;" [src]="machine.firewallOrders[0].partImage">
						</div>
					</div>

					<!-- No active EDI order -->
					<div *ngIf="machine.firewallOrders.length == 0" class="no-job-box">
						<div style="display:flex; align-items:flex-start; gap:12px;">
							<div class="no-job-img"></div>
							<div style="flex:1; min-width:0;">
								<p style="color:white; font-size:0.75rem; font-weight:500; margin:0 0 2px 0;">No Job Assigned.</p>
								<p style="color:#d1d5db; font-size:0.7rem; margin:0 0 2px 0;"></p>
								<p style="color:#9ca3af; font-size:0.65rem; margin:0 0 6px 0;"></p>
							</div>
						</div>
						<div style="margin-top:4px; height:4px; background-color:#4b5563; border-radius:99px;"></div>
					</div>

					<!-- Divider -->
					<div style="border-top: 1px solid #383046; margin: 8px 0;"></div>

					<!-- Next 3 FW jobs -->
					<div>
						<h4 style="color:#77787F; font-size:0.72rem; margin-bottom:7px;">Next Jobs</h4>
						<div style="display:flex; flex-direction:column; gap:5px;">
							<ng-container *ngFor="let stage of getFwNextJobsPadded(machine)">
								<div *ngIf="stage" class="next-job-item">
									<div class="next-job-img"><img [src]="stage.partImage" alt="Part"></div>
									<div style="flex:1; min-width:0;">
										<p style="color:white; font-size:0.88rem; font-weight:500; margin:0 0 1px 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{stage.partNumber}}</p>
										<p style="color:white; font-size:0.83rem; margin:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">Pkg: {{stage.partPackagingExternalName}} &middot; {{stage.clientName}} &middot; Qty: {{stage.quantityOrdered}}</p>
									</div>
								</div>
								<div *ngIf="!stage" class="next-job-item next-job-empty">
									<div class="next-job-img next-job-img-empty"></div>
									<p style="color:#77787F; font-size:0.88rem; margin:0; font-style:italic;">No Job Queued</p>
								</div>
							</ng-container>
						</div>
					</div>

				</ng-container>

			</div>
		</div>
	</div>
</div>
